import { useMutation, useQueryClient, type UseMutationOptions } from '@tanstack/react-query'

import { invalidateGa4 } from './invalidate'

/**
 * A mutation on the GA4 connection. Whatever it does, the connection's health,
 * the Integrations badge and the Traffic numbers are refreshed when it settles
 * — after a refusal as well as a success, since a refused import still leaves
 * a new cooldown to show. A caller's own `onSettled` runs first; anything that
 * should happen only on success goes in `onSuccess`, as usual.
 */
export function useGa4Mutation<TData, TVariables>(options: UseMutationOptions<TData, Error, TVariables>) {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    onSettled: async (...args) => {
      await options.onSettled?.(...args)
      await invalidateGa4(queryClient)
    },
  })
}
